/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Delete_ConfirmInputs */



/**
* | output |
* | --- |
* | "Yes, delete it" |
*
* @param {Explorer_Info_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_delete_confirm = /** @type {((inputs?: Explorer_Info_Delete_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Delete_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Oui, supprimer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ja, lösch es.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sì, eliminalo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Да, удалите это.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sí, bórralo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("是的，删除它")
	if (locale === "ja") return /** @type {LocalizedString} */ ("はい、削除します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("हां, इसे हटा दें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sim, apague-o.")
	return /** @type {LocalizedString} */ ("Yes, delete it")
});